import React, { useEffect, useState, FC, useCallback } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeflex/primeflex.css';
import './style.css';
import { MultiSelect } from "primereact/multiselect";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Dropdown } from 'primereact/dropdown';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import CustomDateRange from '../customDateRange/CustomDateRange';
import moment from 'moment';
import csvDownload from "json-to-csv-export";
import { getAllDetails, getPropertyCharts, getRollingChartsDetailsSymbolWise, getSymbolsDetails, getTableExport } from '../../api/otherEndPoints/optionPerformance';
import jsPDF from 'jspdf';
import ImageExport from '../base64_images/feedsense_image';
import {generaliseExportCSV, optionsPerformanceMetricMapping, optionsPerformanceMetricMappingTableHeader, optionsPositivePeriodAndMarketBeatMapping, optionsPositivePeriodAndMarketBeatMappingTableHeader } from '../../services/util/util';
import GeneralisePreviewTable from '../adviceStatus/GeneralisePreviewTable';
require('jspdf-autotable');


interface UserData {
  s_duration: string[];
  ocValues: number[];
  returnAfterCostValues: number[];
  maxDrawdown: number[];
  successPercentageValues: number[];
}

interface Rolling {
  s_symbol: string,
  Total_Trade: number,
  Total_PL: number,
  Success_Ratio: number,
  Return_with_cost: number,
  Return_DrawdowN: number,
  Return: number,
  Positive_Months: number,  
  Positive_Days: number,
  PL_ratio: number,
  Gross_Profit: number,
  Gross_Loss: number,
  EMR: number,
  Drawdown: number,
}

interface displaySymbols{
  name: string,
  value: string
}

const App: FC = () => {
  const [users, setUsers] = useState<any>([]);
  const [selectedSymbol, setselectedSymbol] = useState<string[]>([]);
  const [symbolsOptions, setSymbolsOptions] = useState<any>();
  const [userData, setUserData] = useState<UserData>({ s_duration: [], ocValues: [], returnAfterCostValues: [], maxDrawdown: [], successPercentageValues: [] });
  const [drpValue, setDrpValue] = useState<string>('N50 OpL-M1');
  const [startDate, setStartDate] = useState<any>('2019-04-09');
  const [endDate, setEndDate] = useState<any>(moment().format("YYYY-MM-DD"));
  const [rolling, getRolling] = useState([]);
  const [isToggled,setToggled] = useState(true)
  const [selectedRisk, getSelectedRisk] = useState<string>('n_drawdown');
  const [selectedReward, getSelectedReward] = useState<string>('n_gross_profit');
  const [selectedMisc, getSelectedMisc] = useState<string>('n_emr');
  const [displayRisk, setDisplayRisk] = useState<{ s_duration: string[]; property: number[] }>({ s_duration: [], property: [] });
  const [displayReward, setDisplayReward] = useState<{ s_duration: string[]; property: number[] }>({ s_duration: [], property: [] });
  const [displayMisc, setDisplayMisc] = useState<{ s_duration: string[]; property: number[] }>({ s_duration: [], property: [] });
  const [exportData, setExportData] = useState<any>()


  //-------------------CSV PREVIEW-------------//
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedPreviewTableData, setSelectedPreviewTableData] = useState<any[]>([]);
  const [selectedPreviewTableColumns, setSelectedPreviewTableColumns] = useState<any[]>([]);
  const [selectedPreviewTableColumnMapping, setSelectedPreviewTableColumnMapping] = useState<any>({});
  const [selectedFileName, setSelectedFileName] = useState<string>("");


  const memorizedExportCSV = useCallback(generaliseExportCSV,[isModalOpen,selectedPreviewTableData]);
  // const onDownload = useCallback(() => memorizedExportCSV(selectedPreviewTableData,selectedPreviewTableColumnMapping,"MonthlyReturns.csv"), [memorizedExportCSV,selectedPreviewTableData]);
  
  const columnRisk = [
    {name: "Drawdown",value:"n_drawdown"}, 
    {name: "Gross Loss",value:"n_gross_loss"},
    {name: "Profit/Loss Ratio",value:"n_pl_ratio"},     
  ]
  const columnReward = [    
    {name: "Gross Profit",value:"n_gross_profit"},    
    {name: "Positive Months",value:"n_positive_months"},
    {name: "Return (%) with cost",value:"n_return_after_cost"},
    {name: "Return (%)",value:"n_return"},
    {name: "Success Ratio",value:"n_success_ratio"},
    {name: "Total PL", value: "n_total_pl"},
  ]

  const columnMisc = [
    {name: "EMR" ,value:"n_emr"}, 
    {name: "Return/Drawdown", value:"n_return_drawdown"}, 
    {name: "Total Trades", value:"n_total_trade"}, 
  ]

  const exportPdfColumns = [
    {name: "Serial No.", value: "serial"},
    {name: "Asset name", value: "asset"},
    {name: "Avg Trades per Year",value:"trades"},
    {name: "Success Ratio (%)",value:"success_ratio"},  
    {name: "Maximum Drawdown (%)",value:"max_drawdown"},
    {name: "Avg P/L Ratio",value:"pl"},
    {name: "Avg Return after cost ",value:"return_cost"},
    {name: "Positive Months(%) ", value:"monthly"}, 
    {name: "Positive Quarter (%) ", value:"quarterly"}, 
  ]

  const exportCols = exportPdfColumns.map((exportPdfColumn) => ({title: exportPdfColumn.name, dataKey: exportPdfColumn.value }));

  function findKeyByValue(obj: any, value1: any): any | undefined {
    let display = obj.find((object:any) => object.value === value1);
    return display["name"]
  }

  const valueBodyTemplate = (rowData: any) => {
    const style = {
        color: rowData.score === '*' ? 'green' : '#ACE1AF',
        fontWeight: 'bold'
    };
    return <span style={style}>{rowData.score}</span>;
};


function addWaterMark(doc: any) {
  var totalPages = doc.internal.getNumberOfPages();  
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(48)
    doc.setFont('Helvetica', 'bold')
    doc.setTextColor(230,230,230);
    doc.text('FeedSense AI', 160,160, null, 45, 'center');
  }  
  return doc;
}

const addFooters = (doc: any) => {
  const pageCount = doc.internal.getNumberOfPages()
  doc.setFont('helvetica', 'italic')
  doc.setTextColor(0,0,0);
  doc.setFontSize(10)
  for (var i = 1; i <= pageCount; i++) {
    doc.setPage(i)
    doc.text('Page ' + String(i) + ' of ' + String(pageCount),260,200)
    if(i == pageCount){
      doc.setFont('Helvetica', 'italic')
      doc.text('Disclaimer: We are using statistical and artificial models etc. which are never error-free. Please apply your own discretions while using this information.',10,200)
    }
  }
}
const exportPdf = () => {
  var doc = new jsPDF('l');
   var image = ImageExport()
   const imageWidth = 50;
   const imageHeight = 15;
   const pageWidth = doc.internal.pageSize.getWidth();
   const imageX = (pageWidth - imageWidth) / 2;
      doc.setFont('Lato-Regular', 'bold')
      doc.setFontSize(13)
      doc.text('Annualized Performance Summary of F&O Models', 145, 35, { align: 'center'});
      (doc as any).autoTable(exportCols, exportData, {
        styles: {
          halign: 'left'
      },
      startY: 40,
      margin: { top: 30 },
      headStyles :{lineWidth: 0.5,fillColor: [224, 224, 224],textColor: [0,0,0]},
      didDrawPage: (data: any) => {
        // Draw image in header (every page)
        doc.addImage(image, 'PNG', imageX, 8, imageWidth, imageHeight);
  
        // Horizontal line
        doc.setLineWidth(0.1);
        doc.line(10, 25, pageWidth - 10, 25);
      },
      theme: 'grid',
    }
   );
  doc = addWaterMark(doc)
  addFooters(doc)
  doc.save('Feedsense AI brochure.pdf');
};
const tradesExports = (data: any, value:number) => {
  if(value === 1){
      const tradeDataToConvert = {
        data: users,
        filename: `Duration Summary`,
        delimiter: ",",
        headers: [
          's_symbol',
          'Total_Trade',
          'Success_Ratio',
          'Total_PL',
          'Gross_Profit',
          'Gross_Loss',
          'PL_ratio',
          'Return',
          'Return_with_cost',
          'Drawdown',
          'Positive_Months',  
          'Positive_Days',
          'EMR',
          'Return_DrawdowN',
        ],
    }
    csvDownload(tradeDataToConvert);
  }
  else{
      const tradeDataToConvert = {
        data: rolling,
        filename: `Rolling Summary`,
        delimiter: ",",
        headers: [
          "s_symbol",
          "positiveDays",
          "rolling_21",
          "rolling_63",
          "score"
        ],
    } 
    csvDownload(tradeDataToConvert);
  }
}

const optionPositiveMonths = {
  title: {
    text: ` ${drpValue} \u00A0(Return after cost %)`,
  },
  xAxis: {
    categories: userData?.s_duration,
    labels: {
      rotation: -90,
      steps:1000,
    }
  },
  tooltip: {
    valueDecimals: 2,
  },
  series: [
    {
      name: 'Return after cost (%)',
      data: userData?.ocValues,
      
    },
  ],
  chart: {
    height: 600,
    type : 'area',
    borderWidth: -1,
    spacingTop: 25
  },
  credits: { enabled: false },
  accessibility: {
    enabled: false
  },
  plotOptions: {
    series: {
        fillOpacity: 0.1,
        color: '#4fc967'
    },
  },
  legend: {
    align: 'right',
    verticalAlign: 'top',
    x: 0,
    y: 0
},
yAxis:{
  gridLineWidth : 0,
},
};

const optionRisk = {
title: {
    text: ``
  },
  xAxis: {
    categories: displayRisk?.s_duration,
    labels: {
      rotation: -90,
      steps:1000,
    }
  },
  tooltip: {
    valueDecimals: 2,
  },
  series: [
    {
      name: `${findKeyByValue(columnRisk,selectedRisk)}`,
      data: displayRisk?.property
    },
  ],
  chart: {
    height: 600,
    type: 'area',
    borderWidth: -1,
    spacingTop: 25
  },
  credits: { enabled: false },
  accessibility: {
    enabled: false
  },
  plotOptions: {
    series: {
        fillOpacity: 0.1,
        color: '#da7958'
    }
},
legend: {
  align: 'right',
  verticalAlign: 'top',
  x: 0,
  y: 0,
},
yAxis:{
gridLineWidth : 0
}
};

const optionReward = {
  title: {
    text: ``
  },
  xAxis: {
    categories: displayReward?.s_duration,
    labels: {
      rotation: -90,
      steps:1000,
    }
  },
  series: [
    {
      name: `${findKeyByValue(columnReward,selectedReward)}`,
      data: displayReward?.property
    },
  ],
  tooltip: {
    valueDecimals: 2,
  },
  chart: {
    height: 600,
    type: 'area',
    borderWidth: -1,
    spacingTop: 25
  },
  credits: { enabled: false },
  accessibility: {
    enabled: false
  },
  plotOptions: {
    series: {
        fillOpacity: 0.1,
        color: '#c7c47d'
    }
},
legend: {
  align: 'right',
  verticalAlign: 'top',
  x: 0,
  y: 0,
},
yAxis:{
gridLineWidth : 0
}
};

const optionMisc = {
  title: {
    text: ``
  },
  xAxis: {
    categories: displayMisc?.s_duration,
    labels: {
      rotation: -90,
      steps:1000,
    }
  },
  series: [
    {
      name: `${findKeyByValue(columnMisc,selectedMisc)}`,
      data: displayMisc?.property
    },
  ],
  chart: {
    height: 600,
    type: 'area',
    borderWidth: -1,
    spacingTop: 25
  },
  credits: { enabled: false },
  accessibility: {
    enabled: false
  },
  plotOptions: {
    series: {
        fillOpacity: 0.1,
        color: '#72418c',
    }
},
legend: {
  align: 'right',
  verticalAlign: 'top',
  x: 0,
  y: 0,
},
yAxis:{
gridLineWidth : 0
}
};

  useEffect(() => {
    try{
      const fetchingAllDetails = async () => {
        let response:any = await  getAllDetails()
        setUsers(response.data[0]); 
        const symbolOptions:displaySymbols = response.data[0].map((item : Rolling) => ({
            name: item.s_symbol, 
            value: item.s_symbol,}))
        const allSymbols = response.data[0].map((item : Rolling) => (
          item.s_symbol))
        setselectedSymbol(allSymbols)
        setSymbolsOptions(symbolOptions);      
        getRolling(response.data[1])        
      }
      fetchingAllDetails()
    }
    catch (error){
      console.error("Error in initial rendering:", error);
    }  
  },[]);

  useEffect(() => {
    const fetchChart = async () => {
          let response:any = await getRollingChartsDetailsSymbolWise(drpValue, startDate, endDate)
          const { s_duration, ocValues, returnAfterCostValues, maxDrawdown, successPercentageValues }:any = response?.data;
          setUserData({ s_duration, ocValues, returnAfterCostValues, maxDrawdown, successPercentageValues });
    }
    if(drpValue || (startDate && endDate)) {
      fetchChart();
    }
  }, [drpValue, startDate,endDate]);

  useEffect(() => {
    const fetchFilteredUsers = async () => {
      let calculation_type = isToggled ? 'product' : 'sum';
        try{
            let response:any = await getSymbolsDetails(selectedSymbol,startDate, endDate, calculation_type)
            setUsers(response[0]);
            getRolling(response[1]);
            let response1: any = await getTableExport(selectedSymbol,startDate, endDate, calculation_type)
            setExportData(response1)
        } 
        catch (error){
          console.error("Error fetching datatable:", error);
        }
      }
    if(selectedSymbol.length > 0 || startDate || endDate){
      fetchFilteredUsers();
    }
  }, [selectedSymbol, startDate,endDate, isToggled]);

  useEffect(() => {
    const fetchChart = async () => {
          const { s_duration, property }:any = await getPropertyCharts(selectedRisk, startDate, endDate, drpValue);
          setDisplayRisk({ s_duration, property });
    }
    if (selectedRisk || (startDate && endDate) || drpValue) {
      fetchChart();
    }
  }, [selectedRisk, startDate,endDate, drpValue]);
  
  useEffect(() => {
    const fetchChart = async () => {
          const { s_duration, property }:any = await getPropertyCharts(selectedReward, startDate, endDate, drpValue);
          setDisplayReward({ s_duration, property });
    }
    if (selectedReward || (startDate && endDate) || drpValue) {
      fetchChart();
    }
  }, [selectedReward, startDate,endDate, drpValue]);

  useEffect(() => {
    const fetchChart = async () => {
          const { s_duration, property }:any = await getPropertyCharts(selectedMisc, startDate, endDate, drpValue);
          setDisplayMisc({ s_duration, property });
    }
    if (selectedMisc || (startDate && endDate) || drpValue) {
      fetchChart();
    }
  }, [selectedMisc, startDate,endDate, drpValue]);

  return (
    <div className="fullpage1">
      <GeneralisePreviewTable
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          columnHeader={selectedPreviewTableColumns}
          tableData={selectedPreviewTableData}
          onDownload={()=>{memorizedExportCSV(selectedPreviewTableData, selectedPreviewTableColumnMapping, selectedFileName)}}
        />
      <div className="card">
        <div className='card_table_strategy'>
        <div className='dropdown1'> 
        <div className='dropdown1_headerName'>
          <MultiSelect  value={selectedSymbol} options={symbolsOptions} onChange={(e) => setselectedSymbol(e.value)} placeholder={selectedSymbol.length === 25 ? 'All symbols': 'Select symbols'} optionLabel="name" className='multiselect' maxSelectedLabels={1} />
          &emsp;&emsp;
          <CustomDateRange backStartDate={startDate} setBackStartDate={setStartDate} backEndDate={endDate} setBackEndDate={setEndDate} />
          <div className='buttonExport'>
          <Button type="button" icon="pi pi-file-pdf" rounded onClick={exportPdf} className='button1' />
            <Button type="button" icon="pi pi-download"
             rounded
             onClick={()=>{
              setSelectedPreviewTableData(users);
              setSelectedPreviewTableColumns(optionsPerformanceMetricMappingTableHeader);
              setSelectedPreviewTableColumnMapping(optionsPerformanceMetricMapping);
              setSelectedFileName("Rolling Details.csv")
              setIsModalOpen(true);
          
          }}

              className='button1' /></div>
          </div>
        </div>
        <div className='datatable1'>
        <DataTable value={users} resizableColumns stripedRows sortMode="multiple">
          <Column field= "s_symbol"  header= "Symbol" frozen sortable style={{ minWidth: '160px'}} ></Column> 
          <Column field= "Total_Trade"  header= "Avg Total Trades" ></Column> 
          <Column field= "Success_Ratio"  header= "Success Ratio" style={{ minWidth: '200px'}} sortable></Column> 
          <Column field= "Total_PL"  header= "Total PL" ></Column> 
          <Column field= "Gross_Profit"  header= "Gross Profit" ></Column> 
          <Column field= "Gross_Loss"  header= "Gross Loss" ></Column> 
          <Column field= "PL_ratio"  header= "P/L ratio" ></Column> 
          <Column field= "Return"  header= "Return (%)" style={{ minWidth: '200px'}} sortable ></Column> 
          <Column field= "Return_with_cost"  header= "Return (%) with cost" ></Column> 
          <Column field= "Drawdown"  header= "Drawdown (%)" ></Column> 
          <Column field= "Positive_Months"  header= "Avg Positive Months" ></Column> 
          <Column field= "EMR"  header= "EMR" ></Column> 
          {/* <Column field= "Positive_Days"  header= "Positive Days" ></Column>  */}
          <Column field= "Return_Drawdown"  header= "Return/Drawdown" ></Column>
        </DataTable>
        </div>
        </div>
        <div className="charts">
          <div className='returnchartCard'>
          <div className='dropdown'>
            <Dropdown value={drpValue} onChange={(e) => {setDrpValue(e.target.value) }} options={symbolsOptions} optionLabel="name" placeholder="Select a Symbol" checkmark={true} highlightOnSelect={false} />
            &emsp;
          </div>
          <div className='returnChart'>  < HighchartsReact highcharts={Highcharts} oneToOne={true} options={optionPositiveMonths} /></div>
          </div>          
          <div className='multicharts_grid'>
            <div className="grid-container">
              <div>
                <div className='customproperty'>
                  <div><h6 className='propertyHeaders'>{drpValue}&nbsp;({findKeyByValue(columnRisk,selectedRisk)})</h6></div>
                  <div className='chartsheader'>
                    <div><h5 className='propertyHeaders'>Risk</h5></div>
                    <div><Dropdown value={selectedRisk} onChange={(e) => getSelectedRisk(e.target.value)} options={columnRisk} optionLabel="name" placeholder="Select a Property" checkmark={true} highlightOnSelect={false}/></div>
                </div>
                </div>
                <HighchartsReact highcharts={Highcharts} oneToOne={true} options={optionRisk}/>
              </div>
              <div>
                <div className='customproperty'>
                  <div><h6 className='propertyHeaders'>{drpValue}&nbsp;({findKeyByValue(columnReward,selectedReward)})</h6></div>
                  <div className='chartsheader'>
                  <div><h5 className='propertyHeaders'>Rewards</h5></div>
                  <div><Dropdown value={selectedReward} onChange={(e) => getSelectedReward(e.target.value)} options={columnReward} optionLabel="name" placeholder="Select a Property" checkmark={true} highlightOnSelect={false} /></div>
                </div>
                </div>
                <HighchartsReact highcharts={Highcharts} oneToOne={true} options={optionReward} />
              </div>
              <div>
                <div className='customproperty'>
                <div><h6 className='propertyHeaders'>{drpValue}&nbsp;({findKeyByValue(columnMisc,selectedMisc)})</h6></div>
                <div className='chartsheader'>
                  <div><h5 className='propertyHeaders'>Miscellaneous</h5></div>
                  <div><Dropdown value={selectedMisc} onChange={(e) => getSelectedMisc(e.target.value)} options={columnMisc} optionLabel="name" placeholder="Select a Property" checkmark={true} highlightOnSelect={false} /></div>
                </div>
                </div>
                <HighchartsReact highcharts={Highcharts} oneToOne={true}  options={optionMisc} />
              </div>
              </div>
          </div>                
        </div>
        <div className='datatable2'>
        <div className='table2_header'>
        <div className='table2_title'><h5 className='adviceStatus_params_heading'>Positive Periods (%)</h5></div>
        <div className='table2_exportButton'><Button type="button"
         icon="pi pi-download"
          rounded
          onClick={()=>{
            setSelectedPreviewTableData(rolling);
            setSelectedPreviewTableColumns(optionsPositivePeriodAndMarketBeatMappingTableHeader);
            setSelectedPreviewTableColumnMapping(optionsPositivePeriodAndMarketBeatMapping);
            setSelectedFileName("Rolling Details.csv")
            setIsModalOpen(true);
        
        }}
           className='button1' /></div>
        </div>
        <div className='rolling_monthly'>
            <DataTable value={rolling} scrollable resizableColumns stripedRows sortMode="multiple" >
            <Column field="s_symbol" header="Symbol" sortable ></Column>
            <Column field="positiveDays" header="Positive Days"  sortable ></Column>
            <Column field="rolling_21" header="Positive Months" sortable ></Column>
            <Column field="rolling_63" header="Positive Quarters"  sortable ></Column>
            <Column field="score" header="Remarks" body={valueBodyTemplate}></Column>
          </DataTable>
        </div>
        </div>
      </div>
    </div>
  );
}
export default App;



